// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1QBM7","tab":"Tabs_tab__3PmEd","tabActive":"Tabs_tabActive__aIwHi"};